import * as React from 'react';
import classnames from 'classnames';
import { Heading } from '@grandvisionhq/elements';

const LineItemTitle = ({ className , title  })=>/*#__PURE__*/ React.createElement(Heading, {
        variant: "subheading1",
        className: classnames('line-item-title', className)
    }, title)
;

export { LineItemTitle as default };
//# sourceMappingURL=LineItemTitle.js.map
